import { canTakeMealBreak, canTakeRestBreak } from '@sdk/automatedBreaks/utils';
import { AutomatedBreaksSettingsUI } from '@sdk/automatedBreaks/types/AutomatedBreaksSettingsUI';
import { Shift } from '@sdk/automatedBreaks/types/Shift';

type Props = {
  shift: Shift;
  automatedBreaksSettings: AutomatedBreaksSettingsUI;
  mealBreaksTaken: number;
  restBreaksTaken: number;
};

const canTakeAutomatedBreak = ({
  shift,
  automatedBreaksSettings,
  mealBreaksTaken,
  restBreaksTaken
}: Props) => {
  const isClockedIn = shift.clockInStatus.clockedIn && !shift.clockInStatus.onBreak;

  if (!isClockedIn) return { meal: false, rest: false };

  return {
    meal: canTakeMealBreak(shift, automatedBreaksSettings, mealBreaksTaken).isAllowed,
    rest: canTakeRestBreak(shift, automatedBreaksSettings, restBreaksTaken).isAllowed
  };
};

export default canTakeAutomatedBreak;
